import { keepPreviousData } from '@tanstack/react-query';

import { useLibraryPostsGateway } from './LibraryPostsGatewayProvider';
import { getCommunityPostsV2InfiniteQueryOptions } from '../api/queryOptions';
import type { LibraryListParams } from '../model/types';

import { useUserScopedInfiniteQuery } from '@/hooks/useUserScopedQuery';

/**
 * The library list, paged in as the reader scrolls.
 *
 * A new search, filter or sort keeps the previous list on screen until the new
 * one lands, flagged by `isPlaceholderData` so the screen can dim it. Skeletons
 * are for when there is nothing to show, including after an account switch,
 * since the scoped query never carries one account's list into another's.
 */
export function useLibraryPosts(params?: LibraryListParams) {
  return useUserScopedInfiniteQuery(
    getCommunityPostsV2InfiniteQueryOptions,
    [params, useLibraryPostsGateway()],
    { placeholderData: keepPreviousData }
  );
}
